import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface RedirectUrl {
  redirectUrl: string;
}

export type GetFullUrlCall = (token: string) => Promise<{ data: RedirectUrl }>;

export default (makeCall: MakeCall) => (token: string) =>
  makeCall<RedirectUrl>('GET', `${APIV2_URL}/shortlink/${token}`);
